// Globals
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// Modules
import { Header } from '@/modules/Layout';

// Components
import { ConversationsTable } from '../../components';
import { StyledContainer } from './ConversationsContainerStyles';

// Helpers
import { getConversationStatusOptions } from '../../helpers';
import { useConversationFilters, useGetConversations } from '../../hooks';

const ConversationsContainer = () => {
  const { t } = useTranslation();
  const { filters, page, handleFilterChange, handlePageChange } = useConversationFilters();
  const { conversations, isLoading, pagination } = useGetConversations(filters, page);

  const statusOptions = useMemo(() => getConversationStatusOptions(t), [t]);

  return (
    <>
      <Header title={t('menu_conversations')} />
      <StyledContainer>
        <ConversationsTable
          data={conversations}
          isLoading={isLoading}
          pagination={pagination}
          onPageChange={handlePageChange}
          filters={filters}
          onFilterChange={handleFilterChange}
          statusOptions={statusOptions}
        />
      </StyledContainer>
    </>
  );
};

export default ConversationsContainer;
